var map = {
	"./arbostar.svg": "4fb1",
	"./beri-dari.svg": "1f74",
	"./guruh.svg": "257b",
	"./hell-store.svg": "8e3a",
	"./jan-van-sundert.svg": "7b9b",
	"./matryoshka.svg": "10bc",
	"./servinga.svg": "ff83",
	"./workflowz.svg": "7ca1",
	"./yobi-da-yobi.svg": "77a6",
	"./yobi.svg": "f330"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4354";